import React from 'react';
import useCountdown from '../hooks/useCountdown';
import { useChainOffset } from '../context/PredictionsContext';

const pad = (n) => String(n).padStart(2, '0');

/**
 * Countdown to a contract timestamp (seconds), on the chain's clock.
 * variant "inline": mm:ss text; "boxes": separate minute/second tiles.
 */
const CountdownTimer = ({ target, onComplete, variant = 'inline', urgentBelow = 30, className = '' }) => {
  const offset = useChainOffset();
  const { days, hours, minutes, seconds, remainingMs } = useCountdown(target ? Number(target) * 1000 : null, onComplete, offset);
  const totalMinutes = days * 1440 + hours * 60 + minutes;
  const urgent = target && remainingMs > 0 && remainingMs < urgentBelow * 1000;

  if (!target) return <span className={`lb-num text-white/40 ${className}`}>--:--</span>;

  if (variant === 'boxes') {
    return (
      <div className={`flex items-center gap-1 ${className}`}>
        {[pad(totalMinutes), pad(seconds)].map((v, i) => (
          <React.Fragment key={i}>
            {i === 1 && <span className="font-bold text-[#a369d9]">:</span>}
            <span className={`lb-num rounded-md bg-black/40 px-2 py-1 text-lg font-bold ${urgent ? 'text-rose-400' : 'text-white'}`}>{v}</span>
          </React.Fragment>
        ))}
      </div>
    );
  }
  return (
    <span className={`lb-num font-bold tabular-nums ${urgent ? 'text-rose-400' : ''} ${className}`}>
      {pad(totalMinutes)}:{pad(seconds)}
    </span>
  );
};

export default CountdownTimer;
